<section
  [attr.aria-labelledby]="headingId()"
  class="relative border-teal-500 bg-surface-darker px-4 pt-8 pb-8 sm:pt-32 sm:pb-32 sm:px-6 lg:px-10"
  [class.border-t]="showTopBorder()"
  [class.border-b]="showBottomBorder()"
>
  <div
    class="mx-auto grid w-full max-w-350 gap-12 lg:grid-cols-[minmax(0,710px)_minmax(0,1fr)] lg:items-start lg:gap-16 xl:gap-24"
  >
    <div class="w-full max-w-[710px] min-w-0">
      <h2
        [id]="headingId()"
        class="max-w-[639px] min-w-0 text-[36px] font-bold leading-[44px] tracking-[0.005em] text-white break-words"
      >
        @for (segment of headingSegments(); track $index) {
          <span [class.text-accent]="segment.accent">{{ segment.text }}</span>
        }
      </h2>

      <p
        class="lead-text-element mt-6 w-full text-[24px] font-bold leading-[29px] tracking-[0.005em] text-white text-start"
      >
        {{ leadText() }}
      </p>

      @if (bodyText(); as text) {
        <p
          class="mt-6 w-full min-w-0 text-[18px] font-normal leading-[22px] tracking-[0.005em] text-[#D9D9D9] text-start break-words"
        >
          {{ text }}
        </p>
      }
    </div>

    @if (showVisual()) {
      <div class="flex justify-center lg:justify-end min-w-0">
        @if (carouselImages(); as images) {
          <div class="w-full max-w-[min(45rem,100%)] px-4 sm:px-0 box-border mx-auto min-w-0">
            <app-image-carousel [images]="images"></app-image-carousel>
          </div>
        } @else {
          <div class="w-full max-w-[min(45rem,100%)] px-4 sm:px-0 box-border mx-auto min-w-0">
            <div
              class="relative aspect-[720/420] w-full max-w-full min-w-0 overflow-hidden rounded-lg border border-accent bg-[#031828] shadow-sm"
            >
              <iframe
                src="https://www.youtube.com/embed/obkavneTmwU"
                title="Sentinel product demo"
                class="absolute inset-0 w-full h-full max-w-full"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                  web-share;
                "
                allowfullscreen
              ></iframe>

              <div
                aria-hidden="true"
                class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(52,211,153,0.12),transparent_35%),linear-gradient(180deg,rgba(3,24,40,0)_0%,rgba(3,24,40,0.28)_100%)]"
              ></div>
            </div>
          </div>
        }
      </div>
    } @else if (primaryAction() || secondaryAction()) {
      <div class="flex min-w-0 items-end lg:self-end lg:justify-end">
        <div
          class="flex w-full flex-col items-stretch gap-4 sm:flex-row sm:flex-wrap sm:items-center lg:w-auto lg:justify-end"
        >
          @if (secondaryAction(); as action) {
            @if (action.register) {
              <button
                type="button"
                class="btn-without-outline h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                (click)="signUp()"
                [appNeetoCalTrigger]="
                  action.label === 'Talk to us about team plans'
                    ? 'User is interested in Team Plans pricing and scaling options.'
                    : undefined
                "
                data-ph-capture-attribute-sc-event="registration started"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </button>
            } @else if (action.routerLink; as routerLink) {
              <a
                class="btn-without-outline h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                [routerLink]="routerLink"
                [appNeetoCalTrigger]="
                  action.label === 'Talk to us about team plans'
                    ? 'User is interested in Team Plans pricing and scaling options.'
                    : undefined
                "
                data-ph-capture-attribute-sc-event="button"
                data-ph-capture-attribute-button="calendar scheduler opened"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </a>
            } @else if (action.href; as href) {
              <a
                class="btn-without-outline h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                [href]="href"
                [appNeetoCalTrigger]="
                  action.label === 'Talk to us about team plans'
                    ? 'User is interested in Team Plans pricing and scaling options.'
                    : undefined
                "
                data-ph-capture-attribute-sc-event="button"
                data-ph-capture-attribute-button="calendar scheduler opened"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </a>
            } @else {
              <button
                type="button"
                class="btn-without-outline h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                [appNeetoCalTrigger]="
                  action.label === 'Talk to us about team plans'
                    ? 'User is interested in Team Plans pricing and scaling options.'
                    : undefined
                "
                data-ph-capture-attribute-sc-event="button"
                data-ph-capture-attribute-button="calendar scheduler opened"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </button>
            }
          }

          @if (primaryAction(); as action) {
            @if (action.register) {
              <button
                type="button"
                class="btn-primary h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                (click)="signUp()"
                data-ph-capture-attribute-sc-event="registration started"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </button>
            } @else if (action.routerLink; as routerLink) {
              <a
                class="btn-primary h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                [routerLink]="routerLink"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </a>
            } @else if (action.href; as href) {
              <a
                class="btn-primary h-[62px] w-full justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
                [href]="href"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </a>
            } @else {
              <span
                class="btn-primary pointer-events-none h-[62px] w-full select-none justify-center px-5 text-[15px] font-semibold leading-none sm:w-auto sm:whitespace-nowrap"
              >
                {{ action.label }}
                <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
              </span>
            }
          }
        </div>
      </div>
    }
  </div>
</section>
